import React from "react";
import { useTranslation } from "react-i18next";

interface ChartDataItem {
  icon: React.ReactNode;
  label: string;
  value: number;
  type?: string;
}

interface EmissionsBreakdownChartProps {
  data: ChartDataItem[];
  title?: string;
  icon?: React.ReactNode;
  titleDetails?: React.ReactNode;
}

const EmissionsBreakdownChart = ({
  data,
  title,
  icon,
  titleDetails,
}: EmissionsBreakdownChartProps) => {
  const { t } = useTranslation();
  const maxValue = Math.max(...data.map((item) => item.value), 0);

  return (
    <div className="w-full py-2">
      {/* Title */}
      {title && (
        <div className="mb-2 flex items-center font-semibold text-gray-800">
          {icon}
          <span className="mb-2">{title}</span>
          <span className="mb-2">{titleDetails}</span>
        </div>
      )}
      {/* Chart */}
      <div className="space-y-0.5">
        {data.map((item, index) => {
          const barWidth = maxValue > 0 ? (item.value / maxValue) * 100 : 0;

          return (
            <div key={index} className="flex items-center text-sm">
              <div className="flex w-60 flex-shrink-0 items-center gap-1.5">
                {item.icon}
                <span className="text-lg font-medium text-black mb-2">
                  {t(item.label)}
                </span>
              </div>
              <div className="flex h-full flex-grow items-center">
                <div className="h-6 flex-grow bg-[var(--body-bg)] rounded-xs">
                  <div
                    className="h-full bg-primary rounded-md flex items-center justify-start"
                    style={{ width: `${barWidth}%` }}
                  >
                    <div className="w-8 text-right font-semibold text-black mb-2 mx-1.5 text-sm">
                      {(item.value / 1000).toFixed(2)}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default EmissionsBreakdownChart;
